// @ts-nocheck
import { IRoute } from '@umijs/core';
import { AnyAction } from 'redux';
import React from 'react';
import { EffectsCommandMap, SubscriptionAPI } from 'dva';
import { match } from 'react-router-dom';
import { Location, LocationState, History } from 'history';

export * from '/root/code/tripairgo-admin/src/models/auth';
export * from '/root/code/tripairgo-admin/src/models/global';
export * from '/root/code/tripairgo-admin/src/models/setting';
export * from '/root/code/tripairgo-admin/src/pages/_Order/model';
export * from '/root/code/tripairgo-admin/src/pages/_TourSell/model';
export * from '/root/code/tripairgo-admin/src/pages/Analytics/model';
export * from '/root/code/tripairgo-admin/src/pages/Area/model';
export * from '/root/code/tripairgo-admin/src/pages/Banner/model';
export * from '/root/code/tripairgo-admin/src/pages/Blog/model';
export * from '/root/code/tripairgo-admin/src/pages/ComboOrder/model';
export * from '/root/code/tripairgo-admin/src/pages/Cost/model';
export * from '/root/code/tripairgo-admin/src/pages/Customer/model';
export * from '/root/code/tripairgo-admin/src/pages/Flight/Accounting/model';
export * from '/root/code/tripairgo-admin/src/pages/Flight/Booking/model';
export * from '/root/code/tripairgo-admin/src/pages/Flight/DepositTopUp/model';
export * from '/root/code/tripairgo-admin/src/pages/Flight/Permission/model';
export * from '/root/code/tripairgo-admin/src/pages/Flight/SignInSetting/model';
export * from '/root/code/tripairgo-admin/src/pages/Flight/SubAgent/model';
export * from '/root/code/tripairgo-admin/src/pages/Flight/User/model';
export * from '/root/code/tripairgo-admin/src/pages/HotelOrder/model';
export * from '/root/code/tripairgo-admin/src/pages/HotelService/model';
export * from '/root/code/tripairgo-admin/src/pages/Menu/model';
export * from '/root/code/tripairgo-admin/src/pages/Order/model';
export * from '/root/code/tripairgo-admin/src/pages/Partner/model';
export * from '/root/code/tripairgo-admin/src/pages/Place/model';
export * from '/root/code/tripairgo-admin/src/pages/Policy/model';
export * from '/root/code/tripairgo-admin/src/pages/Receipt/model';
export * from '/root/code/tripairgo-admin/src/pages/Role/model';
export * from '/root/code/tripairgo-admin/src/pages/Staff/model';
export * from '/root/code/tripairgo-admin/src/pages/Supplier/model';
export * from '/root/code/tripairgo-admin/src/pages/TicketService/model';
export * from '/root/code/tripairgo-admin/src/pages/Tour/model';
export * from '/root/code/tripairgo-admin/src/pages/TourGuide/model';
export * from '/root/code/tripairgo-admin/src/pages/TourSell/model';
export * from '/root/code/tripairgo-admin/src/pages/User/model';
export * from '/root/code/tripairgo-admin/src/pages/VehicleService/model';
export * from '/root/code/tripairgo-admin/src/pages/Visa/model';
export * from '/root/code/tripairgo-admin/src/pages/VisaService/model';

export interface Action<T = any> {
  type: T
}

export type Reducer<S = any, A extends Action = AnyAction> = (
  state: S | undefined,
  action: A
) => S;

export type ImmerReducer<S = any, A extends Action = AnyAction> = (
  state: S,
  action: A
) => void;

export type Effect = (
  action: AnyAction,
  effects: EffectsCommandMap,
) => void;

/**
 * @type P: Type of payload
 * @type C: Type of callback
 */
export type Dispatch<P = any, C = (payload: P) => void> = (action: {
  type: string;
  payload?: P;
  callback?: C;
  [key: string]: any;
}) => any;

export type Subscription = (api: SubscriptionAPI, done: Function) => void | Function;

export interface Loading {
  global: boolean;
  effects: { [key: string]: boolean | undefined };
  models: {
    [key: string]: any;
  };
}

/**
 * @type P: Params matched in dynamic routing
 */
export interface ConnectProps<
  P extends { [K in keyof P]?: string } = {},
  S = LocationState,
  T = {}
> {
  dispatch?: Dispatch;
  // https://github.com/umijs/umi/pull/2194
  match?: match<P>;
  location: Location<S> & { query: T };
  history: History;
  route: IRoute;
}

export type RequiredConnectProps<
  P extends { [K in keyof P]?: string } = {},
  S = LocationState,
  T = {}
  > = Required<ConnectProps<P, S, T>>

/**
 * @type T: React props
 * @type U: match props types
 */
export type ConnectRC<
  T = {},
  U = {},
  S = {},
  Q = {}
> = React.ForwardRefRenderFunction<any, T & RequiredConnectProps<U, S, Q>>;

